<header style="padding-right: 180px;">
  <h2>Tipo de llamada</h2>
</header>
<mat-dialog-content style="padding-bottom: 0">
  <div class="campo">
    <label style="padding-left: 10px;">Tipo de llamada</label>
    <mat-select class="bordeVerde" class="bordeVerde" [(ngModel)]="tipo">
      <mat-option *ngFor="let opt of tiposLlamadas" [value]="opt.codi.trim()">{{opt.codi.trim() +" "+ opt.descripcio.trim()}}</mat-option>
    </mat-select>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center" style="margin-bottom: 20px; margin-top:10px;">
  <button style="width: 50%;" class="btnCCNewOscuro" mat-flat-button [disabled]="!puedeGuardar()" (click)="guardar()">Guardar</button>
</mat-dialog-actions>


